import type React from 'react';

/**
 * Props interface for CodeblockError component
 */
interface CodeblockErrorProps {
  message?: string;
  sectionId?: string;
  showDetails?: boolean;
}

/**
 * Error fallback component for failed codeblock processing
 * Displays user-friendly error message when EJS template processing fails
 */
const CodeblockError: React.FC<CodeblockErrorProps> = ({
  message = 'Failed to process template',
  sectionId,
  showDetails = false,
}) => {
  return (
    <div
      className="codeblock-error-container"
      data-section-id={sectionId}
      style={{
        padding: '16px',
        margin: '16px 0',
        backgroundColor: '#fef2f2',
        border: '1px solid #fecaca',
        borderRadius: '8px',
        color: '#dc2626',
      }}
    >
      <div className="codeblock-error-content">
        <div className="error-icon" style={{ marginBottom: '8px' }}>
          ⚠️
        </div>
        <h3
          className="error-title"
          style={{
            margin: '0 0 8px 0',
            fontSize: '16px',
            fontWeight: '600',
          }}
        >
          Template Processing Error
        </h3>
        <p
          className="error-message"
          style={{
            margin: '0',
            fontSize: '14px',
            lineHeight: '1.5',
          }}
        >
          {message}
        </p>

        {showDetails && sectionId && (
          <div
            className="error-details"
            style={{
              marginTop: '12px',
              padding: '8px',
              backgroundColor: '#fef7f7',
              borderRadius: '4px',
              fontSize: '12px',
              fontFamily: 'monospace',
            }}
          >
            Section ID: {sectionId}
          </div>
        )}

        <div
          className="error-help"
          style={{
            marginTop: '12px',
            fontSize: '12px',
            color: '#991b1b',
          }}
        >
          The content will continue to load normally. Other sections are not
          affected.
        </div>
      </div>
    </div>
  );
};

export default CodeblockError;
export type { CodeblockErrorProps };
